import React, { useEffect } from "react";
import { campodigital} from "../../json/campodigital";
import "./campodigital.css";

const Campo = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="container convocatoria-container">
      <div className='row'>
            <div className='col_12'>
                <div className='convocatoria_title'>
                    <h1>Ventanilla 2026</h1>
                    
                </div>
            </div>
        </div>
        <div className="row">          
          {campodigital.map((item) => (            
            <div className="col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="sec_convocatoria">
                    <h5>{item.nombre} <p className="anio">{item.anio}</p></h5>
                  </div>
                  <hr className="hr-gob" />
                  <div className="row mt-2">
                    <div class="btn-group" role="group">
                      {item.formatos !== undefined ? (
                        item.formatos.map((formato) => (
                          <a
                            className={"btn btn-sm btn-" + formato.id}
                            href={formato.enlaceformato}
                            target={"_blank"}
                          >
                            {formato.nombreformato}
                          </a>
                        ))
                      ) : (
                        <>
                          <p className="doc">No se requieren formatos</p>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="btn-convocatoria">
                    <a
                      className="tn btn-sm btn-"
                      href={item.enlace}
                      target={"_blank"}
                    >
                      Ir
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}



        </div>        

        <a className='convocatoria_historicas' href="" >Consulta, Descarga y llena los Anexos requeridos para ingresar una solicitud</a>
       
      </div>
     
    </>
  );
};

export default Campo;
